import { cn } from '@/lib/utils';
import type { UserAccountStatus } from '../../utils/users-roles.utils';

type UserStatusBadgeProps = {
  status: UserAccountStatus;
};

const STATUS_LABEL: Record<UserAccountStatus, string> = {
  invited: 'Invited',
  active: 'Active',
  deactivated: 'Deactivated',
};

const STATUS_CLASS_NAMES: Record<UserAccountStatus, string> = {
  invited: 'bg-primary-50 text-primary-600',
  active: 'bg-success-background text-success-high-emphasis',
  deactivated: 'bg-muted text-muted-foreground',
};

const DOT_CLASS_NAMES: Record<UserAccountStatus, string> = {
  invited: 'bg-primary-600',
  active: 'bg-success',
  deactivated: 'bg-neutral-400',
};

export const UserStatusBadge = ({ status }: UserStatusBadgeProps) => (
  <span
    className={cn(
      'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium',
      STATUS_CLASS_NAMES[status]
    )}
  >
    <span className={cn('size-1.5 rounded-full', DOT_CLASS_NAMES[status])} aria-hidden />
    {STATUS_LABEL[status]}
  </span>
);
